import VideoSliderPortrait from "@components/Modules/VideoSliderPortrait/VideoSliderPortrait";
import { configCategory } from "@pub/config";
import {
  Arrow,
  CustomClassContext,
  VideoGalleryPortrait,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../category.module.css";
import { CategoryLayoutElementProps } from "../types/types";

export default function CategorySocialVideoPortraitBlock({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const customClass = useContext(CustomClassContext);
  const sectionContainerClass = customClass?.categoryLayout?.sectionContainer;

  if (
    !configCategory.socialVideoPortrait?.display ||
    !data.socialVideoBlock ||
    data.socialVideoBlock.teasers.length === 0
  ) {
    return null;
  }

  return configCategory.socialVideoPortrait.variant === "slider" ? (
    <section
      className={cx(
        styles.bodyContainer,
        styles.socialVideoContainer,
        sectionContainerClass,
      )}
    >
      <VideoSliderPortrait
        title={data.socialVideoBlock.title}
        titleZH={data.socialVideoBlock.titleZH}
        cta={{
          url: data.socialVideoBlock.url,
          headingIcon: configCategory.socialVideoPortrait.viewMore?.icon,
        }}
        items={data.socialVideoBlock.teasers.map((teaser) => ({
          caption: "",
          videoUrl: teaser.embedUri,
        }))}
      />
    </section>
  ) : (
    <section className={cx(styles.bodyContainer, styles.socialVideoContainer)}>
      <VideoGalleryPortrait
        title={data.socialVideoBlock.title}
        items={data.socialVideoBlock.teasers.map((teaser) => ({
          caption: "",
          videoUrl: teaser.embedUri,
        }))}
        leftIcon={<Arrow size={54} direction="left" />}
        rightIcon={<Arrow size={54} />}
        imgWidth="250px"
        imgHeight="450px"
        noOfItemsInView={3}
        description=""
        withDivider={false}
      />
    </section>
  );
}
